import styled from 'styled-components';
import * as Primitive from '@radix-ui/react-progress';
import { colors, relatedChartColors } from 'ui/theme/colors';
import { PROGRESS_INDICATOR_TRANSITION_TIME_IN_MS } from './Progress.constants';
import { ProgressVariants } from './Progress.types';
import { borderRadius, spacing } from 'ui/theme';

export const ProgressContainer = styled(Primitive.Root)`
  position: relative;
  overflow: hidden;
  background: ${colors.backgroundTertiary};
  border-radius: ${borderRadius.md};
  width: 100%;
  height: ${spacing.half};
  transform: translateZ(0);
`;

export const ProgressIndicator = styled(Primitive.Indicator)`
  width: 100%;
  height: 100%;
  transition: transform ${PROGRESS_INDICATOR_TRANSITION_TIME_IN_MS}ms cubic-bezier(0.65, 0, 0.35, 1);

  &[data-variant="${ProgressVariants.error}"] {
    background: ${colors.red100};
  }
  
  &[data-variant="${ProgressVariants.info}"] {
    background: ${relatedChartColors.bluePalette.second};
  }

  /** green 'success' is default */
  &,
  &[data-variant="${ProgressVariants.success}"] {
    background: ${colors.green100};
    background-color: ${relatedChartColors.greenPalette.second};
  }
`;
